var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.channelUsers.$isLoading)?_c('fa-icon',{staticClass:"mr-1 fa-spin",attrs:{"icon":"fa-solid fa-spinner"}}):(_vm.channelUsers.paginationMeta)?_c('b-badge',[_vm._v(" "+_vm._s(_vm.channelUsers.paginationMeta.totalElements)+" ")]):_c('b-badge',[_vm._v("no data")])
}
var staticRenderFns = []

export { render, staticRenderFns }